import {server} from "@o2oa/o2core-js";

const service = {
    "name": "collect",
    "host": "",
    "context": "/o2_collect_assemble"
}

const actions = {
    "who" : {"uri": "/jaxrs/authentication"},
    "captcha": {"uri": "/jaxrs/captcha/width/96/height/40"},
    "login" : {"uri": "/jaxrs/authentication/captcha/key/{key}/answer/{v}", method: "post"},
    "logout" : {"uri": "/jaxrs/authentication", method: "delete"},
    "listApplications": {"uri": "/jaxrs/application2/list/paging/{page}/size/{size}", method: "post"},
    "listRes": {"uri": "/jaxrs/attachment/list/res"},
    "uploadRes": {"uri": "/jaxrs/attachment/upload/res", method: "post", enctype: "formdata"},
    "getRes": {"uri": "/jaxrs/attachment/{id}"},
    "deleteRes": {"uri": "/jaxrs/attachment/{id}", method: "delete"},
    "createApp": {"uri": "/jaxrs/application2", method: "post"},
    "uploadApp": {"uri": "/jaxrs/attachment/upload/app/{appId}", method: "post", enctype: "formdata"},
    "updateApp": {"uri": "/jaxrs/application2/{id}", method: "post"},
    "getApp": {"uri": "/jaxrs/application2/{id}"},
    "downloadApp": {"uri": "/jaxrs/attachment/download/{id}"},
    "getAppFile": {"uri": "/jaxrs/attachment/list/app/{appId}/type/(0)"},
    "publish": {"uri": "/jaxrs/application2/{id}/publish"},
    "listUnits": {"uri": "/jaxrs/unit/list/paging/{page}/size/{size}", method: "post"},
    "getUnit": {"uri": "/jaxrs/unit/{flag}"},
    "updateUnit": {"uri": "/jaxrs/unit/{id}", method: "PUT"}

}

const action = server.getAction(actions, service);
export {action};
